import _ from 'lodash';

import {Component, Module} from 'app/decorators';
import BlndTable from 'app/common/table';

import {stateFilters} from '../constants';
import CompanyIdPicker from 'app/directives/company-id.picker';
import ProductPicker from 'app/directives/product.picker';
import {SendEstimatePDFCtrl, SendFormPDFCtrl, SendAndPrintFormCtrl} from '../ctrls.js';

import tpl from './list.html';
import sendEstimationFormTpl from '../templates/send.estimation.form.html';


@Module({
    name: "app.orders.components.list",
    modules: [
        CompanyIdPicker,
        ProductPicker,
    ],
})
@Component({
    selector: 'order-list',
    bindings: {
        customer: '=?',
        extraFields: '<',
    },
    template: tpl,
})
export default class C {
    constructor ($state, $scope, $element, $stateParams, $timeout, NgTableParams, OrderStore, SecureUrlService, UserService, R, Modal) {
        "ngInject";
        this.stateFilters = stateFilters;
        this.$stateParams = $stateParams;
        this.secureUrlService = SecureUrlService;
        this.$user = UserService.$user;
        this.R = R;
        this.$element = $element;
        this.$state = $state;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.Modal = Modal;
        let defaultFields = [
            'id', 'order_id', 'customer', 'company',
            'crop', 'acres', 'analysis',
            'created_at', 'status', 'applicators',
        ];

        this.defaultParams = {
            search: '',
            created_at__range: '',
            status: 'open',
            ordering: ['-created_at'],
            page_size: 20,
            field: _.concat(defaultFields, this.extraFields),
            contains_product: null,
        };

        if (this.customer) {
            this.defaultParams.customer = this.customer.id;
        }

        this.resetParams();
        this.selectedContainsProduct = null;
        this.searchMode = 'order';
        this.searchModeLabel = 'Order';
        this.applyQSParams();

        this.table = new BlndTable(
            NgTableParams, OrderStore,
            {
                defaultParams: this.defaultParams,
                params: this.params,
                onChange: (params) => this.onChange(params)
            }
        );

        this.selectedObjects = [];
        this.watcher = null
    }

    $onInit () {
        let self = this;
        self.canExport = true;
        self.watcher = self.$scope.$watch(() => self.table.checked, function() {
            let orders = self.table.store.list;
            let checked = self.table.checked;

            self.companies = {};
            self.selectedObjects = self.table.getSelectedObjects();
            _.each(_.range(0, _.keys(checked).length), function (index) {
                let order = orders[index];
                if (order && checked[order.id]) {
                    self.companies[order.company.id] = true;
                }
            });
            self.canExport = _.keys(self.companies).length <= 1;
            self.companyIDs = [];
            angular.forEach(self.table.checked, function (value, key) {
                if (value) {
                    let order = orders.filter(obj => obj.id == key);
                    angular.forEach(order, function (item) {
                        self.companyIDs.push(item.company.id);
                    });
                }
            });
            self.canPrint = _.uniq(self.companyIDs).length <= 1;
            self.canSend = _.uniq(self.companyIDs).length <= 1;
            self.table.updateAllChecked();
        }, true);
    }

    export (type) {
        let self = this;
        let selectedTicket = self.table.getSelected();

        self.secureUrlService.openInNewWindow(self.R.one('export', type), {id: selectedTicket});
    }


    $onDestroy () {
        if (this.watcher) {
            this.watcher();
            this.watcher = null;
        }
        this.table.onDestroy();
        delete this.table;
        this.$element.remove();
        this.$element = null;
    }

    applyQSParams () {
        let params = {};
        for (let k of Object.keys(this.$stateParams)) {
            let v = this.$stateParams[k];
            if (!_.isUndefined(v)) {
                params[k] = v;
            }
        }

        params.company = parseInt(params.company) || undefined;
        params.page = parseInt(params.page) || undefined;
        params.contains_product = parseInt(params.contains_product) || null;

        delete params.customerId;
        _.extend(this.params, params);
    }

    onChange (params_) {
        // clear current params:
        let params = {};
        for (let [k, v] of Object.entries(this.$state.$current.params)) {
            if (v.location === 'search') {
                params[k] = undefined;
            }
        }
        params = _.extend(params, params_);
        this.$state.go('.', params, {notify: false});
    }

    resetParams () {
        this.params = _.clone(this.defaultParams);
        this.selectedContainsProduct = null;
        this.searchMode = 'order';
        this.searchModeLabel = 'Order';
    }

    setSearchMode (mode) {
        const labels = { order: 'Order', product: 'Product' };
        this.searchMode = mode;
        this.searchModeLabel = labels[mode];
        if (mode === 'order') {
            this.selectedContainsProduct = null;
            this.params.contains_product = null;
            this.$timeout(() => {
                const input = this.$element[0].querySelector('.order-search-input-wrapper input[type="text"]');
                if (input) input.focus();
            });
        } else {
            this.params.search = '';
            this.$timeout(() => {
                const toggle = this.$element[0].querySelector('.order-list-page-product-picker .ui-select-toggle');
                if (toggle) toggle.click();
            });
        }
        this.refresh();
    }

    onContainsProductChange () {
        this.params.contains_product = this.selectedContainsProduct
            ? this.selectedContainsProduct.id
            : null;
        this.refresh();
    }

    refresh () {
        return this.table.refresh(this.params);
    }

    openSendEmail (type) {
        let controller = SendEstimatePDFCtrl;
        if (type === 'form') {
            controller = SendFormPDFCtrl;
        } else if (type == 'send_and_print') {
            controller = SendAndPrintFormCtrl;
        }

        let self = this;
        let $modal = this.Modal.open({
            template: sendEstimationFormTpl,
            controller: controller,
            size: 'large',
            resolve: {
                order: () => self.selectedObjects,
            }
        });

        $modal.result.then(function(){
            self.$growl.success('E-mail has been sent');
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/orders/components/list.js